export default {
  Community: {
    title: "المجتمع",
    description: "تبادل المعرفة بين الأطباء حول الحالات السريرية",
    all_cases: "جميع الحالات",
    my_cases: "حالاتي",
    case: {
      shareLink: {
        1: "شاهد الحالة",
        2: "على المنصة “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
  },
  h1_community: "مجتمع الأطباء",
};
